import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChooseMaterialPage } from './choose-material';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    ChooseMaterialPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(ChooseMaterialPage),
  ],
})
export class ChooseMaterialPageModule {}



// WEBPACK FOOTER //
// ./src/pages/choose-material/choose-material.module.ts